// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kx-3";
export var downloadButton = "_kx-4";
export var fileContainer = "_kx-9 _kx-7";
export var fileContainerBase = "_kx-7";
export var fileContainerBaseSm = "_kx-a _kx-7";
export var fileContainerFixedHeight = "_kx-8 _kx-7";
export var fileContainerFixedHeightSm = "_kx-c _kx-a _kx-7";
export var fileContainerSm = "_kx-b _kx-a _kx-7";
export var fileInfo = "_kx-5";
export var fileInfoWidthRestricted = "_kx-6";
export var fileType = "_kx-1";
export var fileTypeName = "_kx-2";
export var fileTypeSm = "_kx-d _kx-1";
export var image = "_kx-0";
export var link = "_kx-f";
export var overflowEllipsis = "_kx-e";